<template>
  <div class="user-management">
    <h2>Edit Users</h2>

    <!-- Add User Form -->
    <div>
      <h3>Add New User</h3>
      <form @submit.prevent="submitNewUser" class="add-user-form">
        <div>
          <label for="userName">User Email</label>
          <input id="userName" v-model="newUser.userName" type="text" placeholder="Enter user email" required>
          <!-- Placeholder for validation feedback, e.g., v-if="isEmailInvalid" -->
          <span v-if="isEmailInvalid" class="error-message">Please enter a valid email.</span>
        </div>
        <div>
          <label for="userPassword">Password</label>
          <input id="userPassword" v-model="newUser.password" type="password" placeholder="Enter password">
        </div>
        <!-- Include other fields as needed -->
        <button type="submit" class="submit-btn">Add User</button>
      </form>
    </div>

    <!-- Display users in a table or list -->
    <div v-if="successMessage" class="success-message">
      {{ successMessage }}
    </div>
    <h3>Registered Users</h3>
    <div v-if="users && users.length">
      <ul class="users-list">
        <li v-for="(user, index) in users" :key="index" class="user-item">
          {{ user.userName }}
          <!-- Delete button with a confirmation step -->
          <button @click="confirmDelete(user.id, user.userName)" class="delete-btn">Delete</button>
        </li>
      </ul>
    </div>
    <div v-else>
      No users found.
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { getUsers, addUser, deleteUser } from '../services/api.js'

export default {
  name: 'UserManagement',
  data() {
    return {
      users: [],
      newUser: {
        userName: '',
        password: '',
      },
    };
  },
  computed: {
    isEmailInvalid() {
      return this.newUser.userName && !/^\S+@\S+\.\S+$/.test(this.newUser.userName);
    }
  },
  methods: {
    async fetchAllUsers() {
      try {
        const usersData = await getUsers();
        this.users = usersData;
      } catch (error) {
        console.error('Failed to fetch users:', error);
      }
    },
    async submitNewUser() {
      try {
        await addUser(this.newUser);
        this.fetchAllUsers(); // Refresh the list of users after adding a new one
        this.newUser.userName = '';
        this.newUser.password = '';
        this.successMessage = 'User added successfully!'; // Set success message
        setTimeout(() => this.successMessage = '', 3000); // Clear message after 3 seconds
      } catch (error) {
        console.error('Failed to add user:', error);
        // Optionally, handle and display error feedback
      }
    },
    async confirmDelete(userId, userName) {
      const confirmation = confirm(`Are you sure you want to delete this user with user name: ${userName}?`);
      if (confirmation) {
        this.submitDeleteUser(userId);
      }
    },
    async submitDeleteUser(userId) {
      try {
        await deleteUser(userId);
        this.fetchAllUsers(); // Refresh the list after deletion
        // Optionally, show a success message
      } catch (error) {
        console.error('Failed to delete user:', error);
        // Optionally, handle and display error feedback
      }
    },
  },
  mounted() {
    this.fetchAllUsers(); // Fetch users data when the component mounts
  },
};
</script>


<style scoped>
/* Styling for UserManagement */
.user-management {
  margin-left: 10px;
  margin-right: 10px;
  padding: 10px;
  border: 3px solid #000000;
  border-radius: 20px;
  background-color: #f1ececc4;
}

.success-message {
  color: green;
  background-color: #ebf9eb;
  border: 1px solid #a5d6a7;
  padding: 10px;
  margin: 10px 0;
  border-radius: 5px;
}

.users-list {
  list-style-type: none;
  padding: 0;
}

.user-item {
  background-color: #ffffff;
  border: 1px solid #ddd;
  margin-bottom: 5px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.delete-btn {
  background-color: #ff4d4f;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}

.delete-btn:hover {
  background-color: #ff7875;
}

.error-message {
  color: #ff4d4f; /* Red color for errors */
  display: block; /* Ensure it appears on a new line */
  margin-top: 5px;
}

.submit-btn {
  background-color: #bbcd13; /* Green background */
  color: white; /* White text */
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #45a049; /* Darker green on hover */
}
</style>
